import { render, staticRenderFns } from "./WEB.vue?vue&type=template&id=6a8a54ff&scoped=true&"
import script from "./WEB.vue?vue&type=script&lang=ts&"
export * from "./WEB.vue?vue&type=script&lang=ts&"
import style0 from "./WEB.vue?vue&type=style&index=0&id=6a8a54ff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8a54ff",
  null
  
)

export default component.exports